import React from 'react';
import NotificationEdit from '@awp/components/Notifications/NotificationEdit';
import NotificationTable from './NotificationTable';

import { FORM_MODE } from '@awp/constants';

import { AwpContainer } from '../Common/AwpContainer';

import { NotificationContextProvider, useNotificationContext } from './NotificationsContext';
import { NotificationTableFilterContextProvider } from './NotificationTableFilterContext';

/**
 * The main Notification component that provides the context and renders the appropriate view.
 *
 * @returns {JSX.Element} The Notification component.
 */
const Notification = () => {
  return (
    <AwpContainer>
      <NotificationContextProvider>
        <NotificationTableFilterContextProvider>
          <NotificationWrapper />
        </NotificationTableFilterContextProvider>
      </NotificationContextProvider>
    </AwpContainer>
  );
};

/**
 * A wrapper component that renders either the NotificationTable or NotificationEdit
 * based on the current mode in the context.
 *
 * @returns {JSX.Element} The NotificationWrapper component.
 */
const NotificationWrapper = () => {
  const { mode } = useNotificationContext();

  return mode === FORM_MODE.LIST ? <NotificationTable /> : <NotificationEdit />;
};

export default Notification;
